import Vue from 'vue';
import Router from 'vue-router';
import WelcomeScreen from '@/views/WelcomeScreen.vue';
import Overview from '@/views/Overview.vue';
import CastingDetail from '@/views/CastingDetail.vue';
import ProfileWizard from '@/views/ProfileWizard.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/sign-in',
      name: 'SignIn',
      component: WelcomeScreen
    },
    {
      path: '/overview',
      name: 'Overview',
      component: Overview,
      children: [
        {
          path: 'casting/:id',
          component: CastingDetail,
          name: 'CastingDetailSheet',
          props: true,
          beforeEnter: (to, from, next) => {
            // If on mobile, redirect to /casting/:id
            if (window.innerWidth < 768) {
              next({ path: `/casting/${to.params.id}` });
            } else {
              next();
            }
          }
        }
      ]
    },
    {
      path: '/casting/:id',
      component: CastingDetail,
      name: 'CastingDetail',
      props: true,
      beforeEnter: (to, from, next) => {
        // If on desktop, redirect to /overview/casting/:id
        if (window.innerWidth >= 768) {
          next({ path: `/overview/casting/${to.params.id}` });
        } else {
          next();
        }
      }
    },
    {
      path: '/profile',
      name: 'ProfileWizard',
      component: ProfileWizard
    },
    {
      path: '/profile-view',
      name: 'Profile',
      component: () => import('@/views/Profile.vue')
    },
    {
      path: '*',
      redirect: '/overview'
    }
  ]
});
